export const getCurrentTab = (callback) => {
  return (dispatch, getState) => {
    const {currentTab} = getState().universityDisplay;
    return dispatch(callback(currentTab));
  };
};

export default getCurrentTab;
